export default __webpack_public_path__ + "static/media/cfund.01eddac6.svg";